import { GridRenderCellParams } from '@microservices/wiskey-react-table-component'

import { DURATION_UNIT } from '@constants'
import { ObjectDataRecord } from '@types'

import { convertToSeconds, isLargeDurationUnit } from '../convertDuration'
import { getTimeFromSeconds } from '../getTimeFromSeconds'

export const renderIntegerAsTimeValueCell = (
  code: string,
  params: GridRenderCellParams<unknown, ObjectDataRecord, unknown>,
  durationUnit?: DURATION_UNIT | null
) => {
  const value: number = params.row[code]

  if (!value && value !== 0) {
    return
  }

  if (isLargeDurationUnit(durationUnit)) {
    return String(value)
  }

  return getTimeFromSeconds(convertToSeconds(value, durationUnit))
}
